export default __webpack_public_path__ + "static/media/link.a1f8d5bb.svg";